// src/components/NotFoundPage.js
import React from 'react';
import PublicLayoutPage from '../components-app/PublicPageLayout';
import {Header,Footer,Databox} from '../components-static/Common';
import {Link} from 'react-router-dom';

export default class NotFoundPage extends React.Component {
    render() {
        return (
            <PublicLayoutPage url="/not-found" title="Page Not Found">
                <div>
                    <Databox active={true} align="center" padding={"20px 0 50px 0"} margin="100px auto" width="1000px" maxWidth="90%">
                        <div>
                            <h2>
                                <img src="/images/input/cancel.png" style={{height:"60px",display:"inline-block",verticalAlign:"middle",margin:"0 20px 0 0"}}/>
                                <span style={{display:"inline-block",verticalAlign:"middle"}}>404 Page does not exist</span>
                            </h2>
                            <div>Please <Link to="/login" title="Return to login page">click here</Link> to return</div>
                        </div>
                    </Databox>
                </div>
            </PublicLayoutPage>
        );
    }
}